// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2RgXe","textarea":"styles_textarea__1CVLI"};